/**
 * Filter definitions and evaluation logic for OrgChart
 */

export const FILTER_KEYS = {
  BPM: "BPM Attendance",
  BIG_EVENT: "Big Event",
  KEY_PLAYER: "Key Player",
  LICENSED: "Licensed",
  NET_LICENSED: "Net Licensed",
  CLIENT: "Client",
};

export const FILTER_COLORS = {
  [FILTER_KEYS.BPM]: "#E85BB0",
  [FILTER_KEYS.BIG_EVENT]: "#F4B63E",
  [FILTER_KEYS.KEY_PLAYER]: "#C7641A",
  [FILTER_KEYS.LICENSED]: "#83D0DA",
  [FILTER_KEYS.NET_LICENSED]: "#0E6E2D",
  [FILTER_KEYS.CLIENT]: "#31A24C",
};

// Priority list: earlier wins when multiple match
export const FILTER_PRIORITY = [
  FILTER_KEYS.BPM,
  FILTER_KEYS.BIG_EVENT,
  FILTER_KEYS.KEY_PLAYER,
  FILTER_KEYS.LICENSED,
  FILTER_KEYS.NET_LICENSED,
  FILTER_KEYS.CLIENT,
];

/**
 * Get the highlight color for a node based on active filters
 * Returns the highest priority matching filter color, or null if no match
 */
export function getNodeFilterColor(userId, activeFilters, ctx) {
  // ctx: { trackerIndex, netLicenseSet }
  if (!activeFilters || activeFilters.size === 0) return null;
  
  for (const key of FILTER_PRIORITY) {
    if (!activeFilters.has(key)) continue;
    
    if (key === FILTER_KEYS.BPM && ctx.trackerIndex.isTraining.has(userId)) {
      return FILTER_COLORS[key];
    }
    if (key === FILTER_KEYS.BIG_EVENT && ctx.trackerIndex.isBigEvent.has(userId)) {
      return FILTER_COLORS[key];
    }
    if (key === FILTER_KEYS.KEY_PLAYER && ctx.trackerIndex.isKeyPlayer.has(userId)) {
      return FILTER_COLORS[key];
    }
    if (key === FILTER_KEYS.LICENSED && ctx.trackerIndex.isLicensed.has(userId)) {
      return FILTER_COLORS[key];
    }
    if (key === FILTER_KEYS.NET_LICENSED && ctx.netLicenseSet.has(userId)) {
      return FILTER_COLORS[key];
    }
    if (key === FILTER_KEYS.CLIENT && ctx.trackerIndex.isClient.has(userId)) {
      return FILTER_COLORS[key];
    }
  }
  
  return null; // no filter hit
}

/**
 * Load filters from localStorage
 */
export function loadFiltersFromStorage() {
  try {
    const stored = localStorage.getItem('orgchart:filters');
    if (stored) {
      const arr = JSON.parse(stored);
      return new Set(arr);
    }
  } catch (e) {
    console.warn('Failed to load filters from storage:', e);
  }
  return new Set();
}

/**
 * Save filters to localStorage
 */
export function saveFiltersToStorage(filters) {
  try {
    const arr = Array.from(filters);
    localStorage.setItem('orgchart:filters', JSON.stringify(arr));
  } catch (e) {
    console.warn('Failed to save filters to storage:', e);
  }
}

